import { useState } from "react";
import { Package } from "lucide-react";

/**
 * Displays a product image if the file exists in
 * /public/assets/products/<slug>/main.jpg, otherwise falls back
 * to an elegant Package icon placeholder. Fully data-driven —
 * no per-product code changes required.
 */
export default function ProductImage({ product, className = "", iconSize = 72 }) {
  const [failed, setFailed] = useState(false);
  const src = product.image || `/assets/products/${product.slug}/main.jpeg`;

  if (failed) {
    return (
      <div className={`flex items-center justify-center bg-neutral-100 text-neutral-300 ${className}`} aria-hidden="true">
        <Package size={iconSize} strokeWidth={1} />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={product.name}
      loading="lazy"
      onError={() => setFailed(true)}
      className={className}
    />
  );
}
